<template>
	<el-card>
		<!-- <div slot="header" class="clearfix">
			<el-button type="primary">添加话题</el-button>
		</div> -->
		<div slot="header" class="clearfix">
		<el-button type="danger" @click="deleteChange(sels)" :disabled="this.sels.length === 0"> 批量删除</el-button>
		</div>
		<el-table ref="multipleTable" :data="discussList" tooltip-effect="dark" style="width: 100%" @selection-change="selsChange">
			<el-table-column type="selection" width="55" ></el-table-column>  //复选框
			<el-table-column prop="id" label="ID" width="50">
			</el-table-column>
			<el-table-column label="话题发起人" prop="userInfo.nickname"></el-table-column>
			<el-table-column prop="title" label="话题名称" show-overflow-tooltip></el-table-column>
			<el-table-column prop="introduce" label="话题描述"></el-table-column>
			<el-table-column prop="create_time" label="创建时间" :formatter="$f.timeFormat" show-overflow-tooltip></el-table-column>
			<el-table-column label="管理" width="200">
				<template slot-scope="scope">
					<!-- <el-button>编辑</el-button> -->
					<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="disDel(scope.row.id,scope.$index)"
					 icon="el-icon-info" iconColor="red" title="确定删除？">
						<el-button slot="reference" type="danger">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next"
		 :total="discussLength">
		</el-pagination>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				sels: [],//选中的值显示
				currentPage: 1,
				pagesize: 0,
				discussList: [],
				discussLength: 0
			}
		},
		created() {
			this.handleCommunityList();
		},
		methods: {
			handleCommunityList() {
				this.$H
					.get("discuss/list", {
						page: this.currentPage
					})
					.then((res) => {
						this.discussList = res.result.data;
						this.pagesize = res.result.per_page;
						this.discussLength = res.result.total;
					})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				console.log(this.currentPage);
				this.handleCommunityList();
			},
			selsChange(sels) {
			    this.sels = sels 
			},
			disDel(id, index) {
				this.$H.post("discuss/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.discussList.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
			},
			deleteChange(index) {
			        var ids= this.sels.map(item => item.id).join()//获取所有选中行的id组成的字符串，以逗号分隔
			        console.log(ids)
			        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).then(() => {      
			            this.$H.post("discuss/del", {
			            	id: ids
			            }).then(res => {
			            	if (res.code == 200) {
			            		this.$message.success('删除成功');
								setTimeout(()=>{
								          location.reload();
								        },1000)
			            	}
			            })
			          }).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	}
</script>

<style>
</style>
